import { CountryCodeToFriendlyNameMapping, ModeToFriendlyNameMapping, DocumentTypeToFriendlyNameMapping, PartnerIdToFriendlyNameMapping, StatusToFriendlyNameMapping, StringDictionary, SupplierIdToFriendlyNameMapping, SalesMotionToFriendlyNameMapping, ChannelToFriendlyNameMapping, PaymentTypeToFriendlyNameMapping } from "../../utils/FriendlyNameMappings"

export interface IDropdownOption {
    key: string | number;
    text: string;
}

export function getOptionsFromDimension(item: any, showCount: boolean): IDropdownOption[] {
    var dropDownOptions: StringDictionary = {}
    if (item.dimension === "eInvPartnerId") {
        dropDownOptions = PartnerIdToFriendlyNameMapping
    }
    else if (item.dimension === "countryCode") {
        dropDownOptions = CountryCodeToFriendlyNameMapping
    }
    else if (item.dimension === "supplier") {
        dropDownOptions = SupplierIdToFriendlyNameMapping
    }
    else if (item.dimension === "mode") {
        dropDownOptions = ModeToFriendlyNameMapping
    }
    else if (item.dimension === "documentType") {
        dropDownOptions = DocumentTypeToFriendlyNameMapping
    }
    else if (item.dimension === "status") {
        dropDownOptions = StatusToFriendlyNameMapping
    }
    else if (item.dimension === "salesMotion") {
        dropDownOptions = SalesMotionToFriendlyNameMapping
    }
    else if (item.dimension === "paymentType") {
        dropDownOptions = PaymentTypeToFriendlyNameMapping
    }
    if (showCount) {
        return Object.entries<number>(item.aggregatedTotals).map(([key, value]) => {
            return { key: key, text: `${!!Object.keys(dropDownOptions).length ? (dropDownOptions[key] ?? key) : key} (${value})` };
        });
    }
    else {
        return Object.entries<number>(item.aggregatedTotals).map(([key, value]) => {
            return { key: key, text: `${!!Object.keys(dropDownOptions).length ? (dropDownOptions[key] ?? key) : key}` };
        });
    }
}

export function getKeyFriendlyName(list: string, key: string) {
    var keyMappings: StringDictionary = {}
    if (list === "status") {
        keyMappings = StatusToFriendlyNameMapping
    }
    else if (list === "mode") {
        keyMappings = ModeToFriendlyNameMapping
    }
    else if (list === "documentType") {
        keyMappings = DocumentTypeToFriendlyNameMapping
    }
    else if (list === "eInvPartnerId") {
        keyMappings = PartnerIdToFriendlyNameMapping
    }
    else if (list === "countryCode") {
        keyMappings = CountryCodeToFriendlyNameMapping
    }
    else if (list === "supplier") {
        keyMappings = SupplierIdToFriendlyNameMapping
    }
    else if (list === "salesMotion") {
        keyMappings = SalesMotionToFriendlyNameMapping
    }
    else if (list === "channel") {
        keyMappings = ChannelToFriendlyNameMapping
    }
    else if (list === "paymentType") {
        keyMappings = PaymentTypeToFriendlyNameMapping
    }
    return !!Object.keys(keyMappings).length ? (keyMappings[key] ?? key) : key
}